module.exports = __webpack_public_path__ + "img/tips3.13daff20.png";